export default __webpack_public_path__ + "static/media/bannerlogo.b173bf4f.svg";